module.exports = __webpack_public_path__ + "img/Ad-Banner-slide-2.3cd34d9f.jpg";